import React from 'react';
import App from '../App';
import ProtectedRoute from '../components/ProtectedRoute';

// Import layouts
import DashboardLayout from '../layouts/DashboardLayout';

// Import page components
import HomePage from '../pages/Home';
import CommissionsPage from '../pages/Commissions';

// Import commission tracker pages
import { 
  SettingsPage, 
  ImportPage, 
  MatchDashboard, 
  ExportPage,
  SavedDataPage,
  CommissionTracker,
  CommissionReports,
  LoginPage,
  ChangePasswordPage
} from '../pages/index.js';
// Direct imports for analytics pages (decoupled from tabbed CallAnalytics)
import CallVolumeTracking from '../pages/CallAnalytics/CallVolumeTracking';
import RecordingManagement from '../pages/CallAnalytics/RecordingManagement';
import CategoryManagement from '../pages/CallAnalytics/components/CategoryManagement';

// Placeholder for Call Quality Phase 4 page
const CallQualityPlaceholder = () => (
  <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>
    <h3>Call Quality Analysis</h3>
    <p>This feature will be available in Phase 4.</p>
    <p style={{ fontSize: '14px' }}>
      Includes call transcription, quality scoring, and negative keyword analysis.
    </p>
  </div>
);

export const ROUTER_CONFIG = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/change-password',
    element: (
      <ProtectedRoute>
        <ChangePasswordPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: '/settings',
        element: <SettingsPage />
      },
      {
        path: '/import',
        element: <ImportPage />
      },
      {
        path: '/match',
        element: <MatchDashboard />
      },
      {
        path: '/export',
        element: <ExportPage />
      },
      {
        path: '/saved-data',
        element: <SavedDataPage />
      },
      {
        path: '/commission-tracker',
        element: <CommissionTracker />
      },
      {
        path: '/commission-reports',
        element: <CommissionReports />
      },
      // Google Analytics section routes (replacing tabbed CallAnalytics component)
      {
        path: '/call-volume',
        element: <CallVolumeTracking />
      },
      {
        path: '/recording-management',
        element: <RecordingManagement />
      },
      {
        path: '/call-quality',
        element: <CallQualityPlaceholder />
      },
      {
        path: '/analytics-settings',
        element: <CategoryManagement />
      },
      // Legacy routes for existing functionality
      {
        path: '/legacy',
        element: <DashboardLayout />,
        children: [
          {
            path: 'home',
            element: <HomePage />
          },
          {
            path: 'commissions',
            element: <CommissionsPage />
          }
        ]
      }
    ]
  }
];
